export default __webpack_public_path__ + "static/media/practice.e2e7c997.png";